import 'core-js/modules/es.object.assign.js';
import { __rest } from '../../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Stack, FormLabel, RadioGroup as RadioGroup$1, FormControlLabel, Radio as Radio$1 } from '@mui/material';
import { styled } from '@mui/material/styles';
import { palette } from '../../foundation/utils.js';

let _ = t => t,
  _t;
const RadioGroup = _a => {
  var {
      margin,
      marginTop,
      marginBottom,
      marginLeft,
      marginRight,
      m,
      marginX,
      marginY,
      mb,
      ml,
      mr,
      mt,
      mx,
      my,
      children,
      id,
      label
    } = _a,
    props = __rest(_a, ["margin", "marginTop", "marginBottom", "marginLeft", "marginRight", "m", "marginX", "marginY", "mb", "ml", "mr", "mt", "mx", "my", "children", "id", "label"]);
  return jsxs(Stack, Object.assign({
    display: "inline-block",
    sx: {
      margin,
      marginTop,
      marginBottom,
      marginLeft,
      marginRight,
      m,
      marginX,
      marginY,
      mb,
      ml,
      mt,
      mr,
      mx,
      my
    }
  }, {
    children: [label && jsx(FormLabel, Object.assign({
      id: id
    }, {
      children: label
    })), jsx(RadioGroup$1, Object.assign({
      id: id
    }, props, {
      children: children
    }))]
  }));
};
const CheckedRadio = styled('div')(_t || (_t = _`
  border-radius: 50%;
  width: 20px;
  height: 20px;
  border: 6px solid ${0};
  box-sizing: border-box;
`), palette('primary'));
const Radio = props => jsx(FormControlLabel, Object.assign({}, props, {
  control: jsx(Radio$1, {
    checkedIcon: jsx(CheckedRadio, {})
  })
}));

export { CheckedRadio, Radio, RadioGroup };
